import type { ComponentProps } from 'react'
import { tv, type VariantProps } from 'tailwind-variants'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/tooltip'
import { getStatusInitials } from '@/utils/get-status-initials'

const sharedStyles = {
  warning: 'bg-alert-warning',
  success: 'bg-alert-success',
  danger: 'bg-alert-danger',
  monochromatic: 'bg-monochromatic-400',
  dangerDark: 'bg-alert-dangerDark',
}

const badgeVariants = tv({
  base: 'size-6 content-center text-white rounded-full text-center text-xs font-bold',
  variants: {
    variant: {
      0: sharedStyles.monochromatic,
      1: sharedStyles.warning,
      2: sharedStyles.warning,
      3: sharedStyles.danger,
      4: sharedStyles.success,
    },
  },
  defaultVariants: {
    variant: 1,
  },
})

export interface ScoreStatusBadgeProps
  extends VariantProps<typeof badgeVariants>,
    ComponentProps<'div'> {
  description: string
}

export function ScoreStatusBadge({
  variant,
  description,
  className,
  ...props
}: ScoreStatusBadgeProps) {
  const isUndefined = variant === 0
  const statusDescription = isUndefined ? 'Processo indefinido' : description

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className={badgeVariants({
              variant,
              className,
            })}
            {...props}
          >
            <span>{getStatusInitials(statusDescription)}</span>
          </div>
        </TooltipTrigger>
        <TooltipContent>{statusDescription}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
